import { FunctionalAnalysisObjectTypeEnum } from '../enums/functional-analysis-object-type-enum';

export class ProvideTransactionFxaDetailsModalPayload {
  type: FunctionalAnalysisObjectTypeEnum;
  resourceName: string;
  characteristicId: number;
  area: string;
}
